module.exports = __webpack_public_path__ + "media/icons/key-2-dark-669900f7.svg";